import { useState } from "react";
import Header from "../../components/common/header";
import GuideTabs from "./components/guide-tabs";
import LiveOrderGuide from "./components/live-order-guide";
import PreOrderGuide from "./components/pre-order-guide";

export default function UserGuide() {
  const [activeTab, setActiveTab] = useState<"pre-order" | "live-order">(
    "pre-order"
  );

  return (
    <div className="flex flex-col h-screen">
      <Header title="이용 방법 총정리" showBackButton />
      <div className="bg-white flex-1 overflow-y-auto">
        <GuideTabs activeTab={activeTab} onTabChange={setActiveTab} />

        {activeTab === "pre-order" ? <PreOrderGuide /> : <LiveOrderGuide />}
      </div>
    </div>
  );
}
